import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";

interface Props {
  card: any[];
  onRepay: (amount: number) => void;
}

const FabCreditTable: React.FC<Props> = ({ card, onRepay }) => {
  const navigate = useNavigate();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Card ID</b>
            </TableCell>
            <TableCell>
              <b>Points</b>
            </TableCell>
            <TableCell>
              <b>Date</b>
            </TableCell>
            <TableCell>
              <b>Status</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {card.map((item) => (
            <TableRow key={item.id}>
              <TableCell>
                <Typography
                  sx={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline"
                  }}
                  onClick={() => navigate("/details/fab-credit")}
                >
                  {item.cardId}
                </Typography>
              </TableCell>
              <TableCell>{item.points}</TableCell>
              <TableCell>{item.date}</TableCell>
              <TableCell>{item.status}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FabCreditTable;
